import { LinkOutlined } from "@ant-design/icons";
import { Button, Row, Typography, message } from "antd";
import { useMediaQuery } from "react-responsive";
import { renderCustomizations } from "./customizations";
import { DomainManagement } from "./DomainManagement";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SingleAppDetail = ({ appName, app, getData, appBundleTechnology, lastDeployDatetime }) => {
    const [mainDomain, setMainDomain] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        if (app?.customizations?.main_domain) {
            setMainDomain(app.customizations.main_domain);
        } else {
            setMainDomain(app?.k8s_ingress?.url);
        }
    }, [app]);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <>
            {app?.k8s_service?.service_type === "NodePort" ? (
                <Row style={{ width: "100%", marginTop: "15px" }}>
                    <Typography.Text>
                        {t("dettaglio_app.single_app_detail.info.1")}
                        <br />
                        {t("dettaglio_app.single_app_detail.info.2")}
                        <br />
                        <br />
                        <Typography.Text
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => {
                                navigator.clipboard.writeText(app?.k8s_ingress?.url);
                                message.success("Copiato negli appunti");
                            }}>
                            Host: {app?.k8s_ingress?.url}
                        </Typography.Text>{" "}
                        <br />
                        <Typography.Text
                            style={{ cursor: "pointer", fontWeight: "bold" }}
                            onClick={() => {
                                navigator.clipboard.writeText(app?.k8s_service?.tcp_port);
                                message.success("Copiato negli appunti");
                            }}>
                            {t("dettaglio_app.single_app_detail.info.port")}:{" "}
                            {app?.k8s_service?.tcp_port}
                        </Typography.Text>{" "}
                        <br />
                        <br />
                        {t("dettaglio_app.single_app_detail.info.3")}
                    </Typography.Text>
                </Row>
            ) : (
                <Row style={{ width: "100%", marginTop: "15px" }}>
                    <Button
                        style={{ fontWeight: "bold", width: isLargeScreen ? "auto" : "100%" }}
                        type="primary"
                        size="large"
                        onClick={() =>
                            window.open("https://" + mainDomain, "_blank", "noreferrer")
                        }>
                        <LinkOutlined />
                        {t("dettaglio_app.single_app_detail.go_to")} {app.technology}
                    </Button>
                </Row>
            )}
            <DomainManagement appName={appName} app={app} getData={getData} />
            {renderCustomizations(appName, app, getData, appBundleTechnology, lastDeployDatetime)}
        </>
    );
};

export { SingleAppDetail };
